import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import './App.css';
import Product from './Product';
import Axios from 'axios';
import Toolbar from '../../components/Toolbar/Toolbar'
import Logout from '../../containers/Login/Logout'

const products = [
  {
    key: 0,
    price: '$5.00',
    name: 'Basic',
    interval: 'month',
    billed: 'monthly',
  },
  {
    key: 1,
    price: '$15.00',
    name: 'Premium',
    interval: 'month',
    billed: 'monthly',
  },
];





function Account({ location }) {

  const [accountInformation, setAccountInformation] = useState(location.state!== undefined ? location.state.accountInformation: null);
  let [customerPaymentMethod, setCustomerPaymentmethod] = useState(null);
  let [subscriptionCancelled, setSubscriptionCancelled] = useState(false);
  let [trialend, setTrialend] = useState('');

  let [trial, setTrial] = useState(false);

  let [selectedProducted, setSelectedProduct] = useState(accountInformation !== null  ? accountInformation.priceId :null
  );
  

  useEffect(() => {
    async function fetchData(paymentMethodID) {
      // You can await here
      if (accountInformation !== null) {
      Axios.post(process.env.REACT_APP_API_BASEURL +'/api/retrieve-customer-payment-method', 

        {
          paymentMethodId: accountInformation.paymentMethodId,
        },
        {
          headers: {
            'Authorization': localStorage.getItem('token')
          }
        }
      )
      .then (response => {
        const responseBody = response.data;
        const paymentMethod =
          responseBody.card.brand + ' •••• ' + responseBody.card.last4;
  
        setCustomerPaymentmethod(paymentMethod);

      });
    }

    else {
      var url_get_subscription = process.env.REACT_APP_API_BASEURL  + "/api/retrieve-subscription";
      var email = localStorage.getItem('email');
      Axios.post(url_get_subscription, {
        params:{email: email},
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .then((response) => {

        if (response.data[0].data.length == 0) {
          setSubscriptionCancelled(true)
        }

        else {
        setTrial(response.data[0].data[0].status == 'trialing')
        if (response.data[0].data[0].status == 'trialing') {
          setTrialend(JSON.stringify(new Date(parseInt(response.data[0].data[0].trial_end)*1000)))
        }
        else {
          setTrialend('')
        }
        console.log(new Date(parseInt(response.data[0].data[0].trial_end)*1000))
        console.log('subscription', response.data[0].data[0])

      }

      Axios.post(process.env.REACT_APP_API_BASEURL +'/api/retrieve-customer-payment-method', 

        {
          paymentMethodId:  response.data[1],
        }, {
          headers: {
            'Authorization': localStorage.getItem('token')
          }
        }
      )
      .then (response => {
        const responseBody = response.data;
        const paymentMethod =
          responseBody.card.brand + ' •••• ' + responseBody.card.last4;
  
        setCustomerPaymentmethod(paymentMethod);

      });

    })


    }

    }
    fetchData();

  }, [accountInformation!== null ? accountInformation.paymentMethodId: null]);




  function cancelSubscription(accountInformation) {

    if (accountInformation !== null) {

    var subscriptionId =  accountInformation.subscription.data.id 

    Axios.post(process.env.REACT_APP_API_BASEURL +'/api/cancel-subscription', {

      
        subscriptionId: subscriptionId,
        email: localStorage.getItem('email'),
      }, {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      }
    )
      .then((response) => {
        return response.data;
      })
      .then((cancelSubscriptionResponse) => {
        setSubscriptionCancelled(true);
      });

    }
    else {
      var url_get_subscription = process.env.REACT_APP_API_BASEURL  + "/api/retrieve-subscription";
      var email = localStorage.getItem('email');
      Axios.post(url_get_subscription, {
        params:{email: email},
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .then((response) => {

        var subscriptionId =  response.data[0].data[0].id


        Axios.post(process.env.REACT_APP_API_BASEURL +'/api/cancel-subscription', {
    
          
            subscriptionId: subscriptionId,
            email: localStorage.getItem('email'),

          }, {
            headers: {
              'Authorization': localStorage.getItem('token')
            }
          }
        )
          .then((response) => {
            return response.data;
          })
          .then((cancelSubscriptionResponse) => {
            setSubscriptionCancelled(true);
          });
      })
    

    }
  }

  function resetDemo() {
    localStorage.clear();
    window.location.href = '/';
  }

  let trialcheck

  if (trial) {
    trialcheck = <div>Trial Ends at {trialend}</div>
  }

  return (
    <div>

    <Toolbar button={<Logout ></Logout>}></Toolbar>



    <div className="p-6">
    
      {subscriptionCancelled ? (
        <div>
          <div className="flex flex-wrap font-bold text-pasha text-xl mt-6 mb-2">
            No subscription present at the moment
          </div>
        </div>
      ) : (
        <div>
          <div className="flex flex-wrap justify-center mt-4">
            <div className="md:w-2/5 w-full inline-block rounded-md p-4">
              <div
                id="subscription-status-text"
                className="text-center font-bold text-pasha text-2xl"
              >
                Account settings
              </div>
              <div className="mt-4 border rounded p-4">
                <div className="font-bold text-xl mb-2">Account</div>
                <div className="flex justify-between text-gray-600 text-xl">
                  <div>Current price</div>
                  <div className="font-bold text-xl mb-2">
                    {selectedProducted!== null? selectedProducted : "Cryptologics-ai Premium Subscription"}
                  </div>

                
                </div>

                <div className="flex justify-between">
                  <div className="text-sm text-gray-600">{trialcheck}</div>

                </div>

                <div className="flex justify-between">
                  <div className="text-xl text-gray-600">Credit card</div>
                  <span
                    id="credit-card-last-four"
                    className="font-bold text-xl text-gray-600"
                  >
                    {customerPaymentMethod}
                  </span>
                </div>


                <div
                  className="flex justify-between mt-2 mb-2 text-gray-900 font-bold text-xl cursor-pointer"
                  onClick={() => cancelSubscription(accountInformation)}
                >
                  <span>
                    Cancel subscription <span>→</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
    </div>
  );
}

export default withRouter(Account);